import {
    FEATURE_TAB_UPDATE_UNIT_REQUEST,
    FEATURE_TAB_UPDATE_UNIT_RESULT,
    FEATURE_TAB_GET_DEVICE_REQUEST,
    FEATURE_TAB_GET_DEVICE_RESULT,
    FEATURE_TAB_OPEN_MODAL,
    FEATURE_TAB_CLOSE_MODAL
} from 'Redux/actionTypes';

export const featureTabOpenModal = (data) => ({
    type: FEATURE_TAB_OPEN_MODAL,
    payload: data,
})

export const featureTabCloseModal = () => ({
    type: FEATURE_TAB_CLOSE_MODAL
})

export const featureTabUpdateUnitRequest = (data) => ({
    type: FEATURE_TAB_UPDATE_UNIT_REQUEST,
    payload: data
})

export const featureTabUpdateUnitResult = (result) => ({
    type: FEATURE_TAB_UPDATE_UNIT_RESULT,
    payload: result
})

export const featureTabGetDeviceRequest = (data) => ({
    type: FEATURE_TAB_GET_DEVICE_REQUEST,
    payload: data
})

export const featureTabGetDeviceResult = (result) => ({
    type: FEATURE_TAB_GET_DEVICE_RESULT,
    payload: result
})